
import React, { useEffect, useState } from 'react';

const CoursePage = () => {
  return (
    <div>
       <iframe style={style}  src="https://d32ceifq1ckm1k.cloudfront.net"></iframe>
    </div>
  );
}

	const style = {
    position: 'absolute',
    border: 'none',
    height: '100vh',
    width: '100vw',
	};

export default CoursePage;